import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Response = Api.Core.ClaimJob.StatusRequirements.IResponse;
type Headers = Api.Core.ClaimJob.StatusRequirements.IHeaders;
const url = '/api/Claims/ClaimJob/StatusRequirements';
export default async function claimJobStatusRequirementsApi(): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
